import angular from 'angular';

import ApplicationPageComponent from './application-page';
import PageHeaderComponent from './page-header';
import PageFooterComponent from './page-footer';
import PageContextComponent from './page-context';
import DomainSelectorComponent from './domain-selector';
import ModalComponent from './modal';
import CartSettingsComponent from './cart-settings';
import AlarmNotificationsComponent from './alarm-notifications';
import EmptyBoxComponent from './empty-box';
import TransportsComponent from './transports';

const module = angular
    .module('app.components', [])
    .component(ApplicationPageComponent.selector, ApplicationPageComponent)
    .component(PageHeaderComponent.selector, PageHeaderComponent)
    .component(PageFooterComponent.selector, PageFooterComponent)
    .component(PageContextComponent.selector, PageContextComponent)
    .component(DomainSelectorComponent.selector, DomainSelectorComponent)
    .component(ModalComponent.selector, ModalComponent)
    .component(AlarmNotificationsComponent.selector, AlarmNotificationsComponent)
    .component(CartSettingsComponent.selector, CartSettingsComponent)
    .component(EmptyBoxComponent.selector, EmptyBoxComponent)
    .component(TransportsComponent.selector, TransportsComponent)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/components/index.js